<template>
    <div>
        <v-layout wrap>
            <v-flex lg2 md2 sm2 xs2>
                <pond-type-list :defaultData="pondType" @getPondType="getPondType" @onView="onViewType" />
            </v-flex>
            <v-flex lg10 md10 sm10 xs10>
                <c-search-form
                    :rows-per-page-items="[10, 20, 50]"
                    :form-name="formName"
                    :fields="fields"
                    :hiddenFields="hiddenFields"
                    key-property="pondId"
                    search-url="/pond/search?sortField=updateAt&"
                    create-url="/pond/save"
                    delete-url="/pond/delete"
                    form-type="intable"
                    custom-create-new
                    @createNew="openCreateDialog"
                    custom-edit-item
                    @editItem="openCreateDialog"
                    ref="tableData"
                    :reload="timeReload"
                    :deleteMulti="false"
                    orderBy="desc"
                    :acceptDelete="false"
                />
            </v-flex>
        </v-layout>
        
        <pond-create
            :propsItem="propsItem"
            :cDialog="visibleCreateDialog"
            :pondType="pondType"
            :areas="areas"
            :hiddenFields="hiddenFields"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import PondCreate from "./PondCreate.vue";
import axios from "axios";
import { cateContants } from "@/constants";
import PondTypeList from "./component/PondTypeList";

export default {
    name: "pond",
    components: { PondCreate, CSearchForm, PondTypeList },
    data: () => {
        return {
            formName: "Danh sách ao",
            formCreateName: "Thêm mới ao",
            propsItem: null,
            visibleCreateDialog: false,
            pondType: [],
            areas: [],
            timeReload: 0,
            hiddenFields: {
                typeId: "0",
            },
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    width: "5%",
                    sortable: false,
                    headerStyle: "text-align:center",
                },
                {
                    value: "code",
                    text: "Mã ao",
                    search: true,
                    headerStyle: "text-align:center",
                },
                // {
                //     value: "name",
                //     text: "Tên ao",
                //     search: true,
                //     headerStyle: "text-align:center",
                // },
                {
                    value: "areaId",
                    text: "Khu nuôi",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "areaId",
                    items: [],
                    itemText: "categoryCode",
                    itemValue: "categoryId",
                },
                {
                    value: "type",
                    text: "Loại ao",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "type",
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: cateContants.pondStatus,
                    itemText: "text",
                    itemValue: "value",
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    width: "60px",
                    compound: true,
                    headerStyle: "text-align:center",
                },
            ],
        };
    },

    created() {
        // khu nuôi
        axios
            .post(
                process.env.VUE_APP_API_URL +
                    "/category/myArea"
            )
            .then((data) => {
                if (data.length > 0) {
                    this.areas = data;
                    let itemFields = this.fields.filter(function (e) {
                        return e.name == "areaId";
                    });
                    if (itemFields != undefined && itemFields.length > 0) {
                        itemFields[0].items = data;
                    }
                }
            });

        // loại ao
        this.getPondType()

        // quy trình nuôi
        // axios
        //     .post(
        //         process.env.VUE_APP_API_URL + "/category/listByType?type=FARMING_PROCESS"
        //     )
        //     .then((data) => {
        //         if (data.length > 0) {
        //             this.procedures = data;
        //             let itemFields = this.fields.filter(function (e) {
        //                 return e.name == "procedureId";
        //             });
        //             if (itemFields != undefined && itemFields.length > 0) {
        //                 itemFields[0].items = data;
        //             }
        //         }
        //     });


        // nhân viên
        // axios
        //     .post(
        //         process.env.VUE_APP_API_URL + "/user/list",
        //         {page: 0}
        //     )
        //     .then((data) => {
        //         if (data.content.length > 0) {
        //             this.users = data.content;
        //             let itemFields = this.fields.filter(function (e) {
        //                 return e.name == "userId";
        //             });
        //             if (itemFields != undefined && itemFields.length > 0) {
        //                 itemFields[0].items = data.content;
        //             }
        //         }
        //     });

        // ao mẹ
        // axios
        //     .post(
        //         process.env.VUE_APP_API_URL + "/pond/search?pageSize=100&page=1&orderBy=asc", {}
        //     )
        //     .then((data) => {
        //         if (data.items.length > 0) {
        //             this.parents = data.items;
        //             let itemFields = this.fields.filter(function (e) {
        //                 return e.name == "parentId";
        //             });
        //             if (itemFields != undefined && itemFields.length > 0) {
        //                 itemFields[0].items = data.items;
        //             }
        //         }
        //     });
    },

    methods: {
        openCreateDialog: function (item = null) {
            this.propsItem = item;
            if (item == null) {
                this.formCreateName = 'Thêm mới ao';
            } else {
                this.formCreateName = 'Cập nhật ao';
            }
            this.visibleCreateDialog = true;
        },
        closeCreateDialog: function () {
            this.propsItem = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        getPondType: function () {
            axios
                .post(
                    process.env.VUE_APP_API_URL +
                        "/category/listByType?type=PONDTYPE"
                )
                .then((data) => {
                    if (data.length > 0) {
                        this.pondType = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "type";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                });
        },
        onViewType(item) {
            if(item.categoryId !=0) {
                this.hiddenFields = Object.assign({}, {"type": item.categoryId});
            }else{
                this.hiddenFields = Object.assign({}, {"type": -1});
            }
        }
    },

    destroyed() {},
};
</script>
